export type SocialPlatform = "twitter" | "linkedin" | "instagram";

const HOST_MATCHERS: Record<SocialPlatform, RegExp[]> = {
  twitter: [/^(www\.)?twitter\.com$/i, /^(www\.)?x\.com$/i],
  linkedin: [
    /^(www\.)?linkedin\.com$/i,
    /^[a-z]{2,3}\.linkedin\.com$/i,
  ],
  instagram: [/^(www\.)?instagram\.com$/i],
};

export function isValidSocialUrl(
  value: string | null | undefined,
  platform: SocialPlatform,
): boolean {
  const s = (value ?? "").trim();
  if (!s) return true;
  if (!/^https:\/\//i.test(s)) return false;
  try {
    const url = new URL(s);
    return HOST_MATCHERS[platform].some((re) => re.test(url.hostname));
  } catch {
    return false;
  }
}

export function toSafeHttpsUrl(value: string | null | undefined): string | null {
  const s = (value ?? "").trim();
  if (!/^https:\/\//i.test(s)) return null;
  try {
    const url = new URL(s);
    return url.protocol === "https:" && url.hostname ? url.href : null;
  } catch {
    return null;
  }
}

export function toSafeSocialUrl(
  value: string | null | undefined,
  platform: SocialPlatform,
): string | null {
  const safe = toSafeHttpsUrl(value);
  if (!safe) return null;
  return isValidSocialUrl(safe, platform) ? safe : null;
}

export const SOCIAL_PLACEHOLDER: Record<SocialPlatform, string> = {
  twitter: "https://twitter.com/username",
  linkedin: "https://linkedin.com/in/username",
  instagram: "https://instagram.com/username",
};

export const SOCIAL_ERROR: Record<SocialPlatform, string> = {
  twitter: "Enter a full https:// twitter.com or x.com URL.",
  linkedin: "Enter a full https:// linkedin.com URL.",
  instagram: "Enter a full https:// instagram.com URL.",
};
